import { LEAFLINK_NO_LONGER_OPEN_STATUSES } from './constants/leaflink-no-longer-open-statuses.js';
const NO_LONGER_OPEN_STATUSES = LEAFLINK_NO_LONGER_OPEN_STATUSES;
export function isLeafLinkNoLongerOpenStatus(status) {
    return status != null && NO_LONGER_OPEN_STATUSES.includes(status);
}
//# sourceMappingURL=is-leaflink-no-longer-open-status.js.map